/**
 * Default projects data for the portfolio section
 * This data is used as a fallback if no customized data exists
 * Each project should have:
 * - id: Unique identifier
 * - title: Project name
 * - description: Short description (1-2 sentences)
 * - fullDescription: Detailed description
 * - images: Array of image paths
 * - tags: Array of technology tags for filtering
 * - url: Optional URL for "Try Now" button
 */

const defaultProjectsData = [
  {
    id: 2,
    title: 'EU funds Investment',
    description: 'MB Ai automation is implementing a digitalization project "financial incentives for startups and spin-offs to develop AI, blockchain technologies, robotics process automation products and solutions"',
    fullDescription: 'The total project value is 111129 EUR, of which 86000 EUR is allocated from the European Regional Development Fund. The project implementation period is from 2024.08 to 2025.05',
    images: ['/images/projects/eu-funds-investment-1.jpg', '/images/projects/eu-funds-investment-1.jpg', '/images/projects/eu-funds-investment-1.jpg'],
    tags: ['EU', 'Funds', 'Investment', 'MVP', 'AI', 'Blockchain', 'Robotics'],
    url: '/assets/queryai-extension-v2-082.zip'
  },
  {
    id: 4,
    title: 'Nordok',
    description: 'An API for Norway\'s Digitoll customs system facilitating consignment transport notifications.',
    fullDescription: 'Nordok handles document management and database synchronization for seamless customs processing. The system automates customs declarations, reducing processing time and minimizing errors in international shipping procedures.',
    images: ['/images/projects/nordok-1.jpg', '/images/projects/nordok-2.jpg', '/images/projects/nordok-3.jpg'],
    tags: ['API Development', 'Norway Customs', 'Node.js', 'PostgreSQL', 'Logistics Automation'],
    url: 'http://nordok.vercel.app'
  },
  {
    id: 1,
    title: 'Query AI',
    description: 'An AI-based customer support assistant enhancing response automation across messaging platforms.',
    fullDescription: 'Query AI provides intelligent suggestions, automates repetitive queries, and improves customer service efficiency. The system learns from interactions and continuously improves its response accuracy and relevance over time.',
    images: ['/images/projects/queryai-1.jpg', '/images/projects/queryai-2.jpg', '/images/projects/queryai-3.jpg'],
    tags: ['AI Chatbot', 'NLP', 'Machine Learning', 'API Integration', 'Customer Support'],
    url: '/assets/queryai-extension-v2-082.zip'
  }
];

export default defaultProjectsData; 